
import React, { useEffect, useState } from 'react';
import DashBoardHolder from '../../Images/dashboardPlaceholder.svg';
import Navbar from '../NavBar/Navbar';
import MapDashboard from '../myproporties/MapDashboard';
import { useLocation, useNavigate } from 'react-router-dom';
import PopUPModal from '../utils/Modal'
import { useUser } from "../utils/UserContext.jsx"; // Import the custom hook
import FadeLoader from "react-spinners/FadeLoader";
import OwnerDashboard from "./OwnerDashboard";

const Dashboard = (props) => {
    const navigate = useNavigate();
    const [isdashboard, setDashboard] = useState(true);
    const [mapvisible, setMapvisible] = useState(false);
    const location = useLocation();
    const { userDetails, employeeData } = useUser();
    const { empDetails } = useUser();
    const { loader } = useUser();
    const [isEmployee, setIsEmployee] = useState(false);
    const [entityId, setEntityId] = useState(null);
    const [empRegistrationId, setEmpRegistrationId] = useState(null)

    const [defaultaddress, setDefaultaddress] = useState("");
    const RegisterProperty = (e) => {
        if (empDetails?.companyEmail?.includes('@geoparking.com')) {
            navigate('/OwnerRegistrationDashboard', { state: { showOwnerRegistration: true } });
        }
        else {
            e.preventDefault();
            setDashboard(false);
            handleMapvisible(true);
        }
    }
    const handleMapvisible = (val) => {
        setMapvisible(val);
    }
    useEffect(() => {
        if (location.state?.isDashboard !== undefined) {
            setDashboard(location.state.isDashboard);
        }
    }, [location.state]);

    useEffect(() => {
        if (userDetails) {
            setDefaultaddress(userDetails.enityMailingAdderess);
            setEntityId(userDetails.entityRegistrationID);
            setIsEmployee(false)
        } else if (employeeData) {
            setIsEmployee(true)
            setDefaultaddress(employeeData.enityMailingAdderess);
            setEntityId(employeeData.entityRegistrationID);
            setEmpRegistrationId(employeeData.empRegistrationID)
        }
    }, [userDetails, employeeData]);
    return (
        <div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            <Navbar mapvisible={mapvisible} userDetails={userDetails} employeeData={employeeData} setMapvisible={handleMapvisible} />
            {isdashboard ? (

    // 🔥 ONLY CHANGE HERE
    empDetails?.companyEmail?.includes('@geoparking.com') ? (

        // ✅ Employee → Keep OLD UI (unchanged)
        <div className="container-fluid p-0">

            <div className="dashboard">
                <div className="rectangle" />
                <div className="rectangle-2" />
            </div>

            <div className="dashboardContainer-fluid DashBoardBody">
                <div className="illustration-auntum">
                    <img
                        className="clip-path-group"
                        alt="Clip path group"
                        src={DashBoardHolder}
                    />
                </div>

                <div>
                    <p className="dashboardheaders">
                        Welcome {empDetails?.firstName || userDetails?.firstName || employeeData?.firstName || "User"} to Your GeoParking Dashboard!
                    </p>

                    <p className="we-re-thrilled-to">
                        {PopUPModal.Dasboard_Description}
                    </p>
                </div>

                <div className="registerframe">
                    <button
                        className='reg-property'
                        onClick={RegisterProperty}
                    >
                        Register Owner
                    </button>
                </div>
            </div>
        </div>

    ) : (
        // ✅ Owner → Show New Dashboard UI
        <OwnerDashboard entityId={entityId} />
    )

)
             : (
                <MapDashboard userData={userDetails} employeeData={employeeData} entityId={entityId} defaultaddress={defaultaddress} mapVisibleChangesAlert={handleMapvisible} defaultRegion={userDetails?.country || employeeData?.country}
                    empRegistrationId={empRegistrationId} isEmployee={isEmployee} />
            )}
        </div>
    );
};

export default Dashboard;